"use client";
import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import VirtualList from "rc-virtual-list";

import { ProjectListMapCard } from "src/components/cards/map/cards/project-card/ProjectListMapCard";
import { ListingListMapCard } from "src/components/cards/map/cards/listing-card/ListingListMapCard";

import styles from "./styles.module.css";

const Listings = ({ listings, isLandPage, isProjectPage }) => {
  const itemHeight = 100;
  const [listHeight, setListHeight] = useState(0);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const screenHeight = window.innerHeight;
      const visibleItemCount = Math.floor(screenHeight / itemHeight);
      setListHeight(itemHeight * visibleItemCount);
    }
  }, []);

  if (!listHeight) return null;

  if (isProjectPage) {
    return (
      <VirtualList data={listings} height={listHeight} itemHeight={itemHeight} itemKey="id" className={styles.wrapper}>
        {(listing, index) => <ProjectListMapCard informations={listing} key={listing.id} index={index} />}
      </VirtualList>
    );
  }

  return (
    <VirtualList data={listings} height={listHeight} itemHeight={itemHeight} itemKey="id" className={styles.wrapper}>
      {(listing, index) =>
        listing?.badge === "project" ? (
          <ProjectListMapCard informations={listing} key={listing.id} index={index} />
        ) : (
          <ListingListMapCard informations={listing} isLandPage={isLandPage} key={listing?.id} index={index} />
        )
      }
    </VirtualList>
  );
};

Listings.propTypes = {
  listings: PropTypes.array,
  isLandPage: PropTypes.bool,
  isProjectPage: PropTypes.bool,
};

export default Listings;
